import axios from "axios";

function login({ email, password, loginContext }) {
  const backend_url = process.env.REACT_APP_BACKEND_URL;
  const timeoutDuration = process.env.REACT_APP_TIMEOUT_DURATION;

  return new Promise(async (resolve, reject) => {
    try {
      let target = `${backend_url}/auth/local`;
      let response;

      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();

      let config = {
        cancelToken: source.token,
        timeout: timeoutDuration,
      };
      response = await axios
        .post(
          target,
          { identifier: email, password: password, loginContext },
          config
        )
        .catch((err) => {
          try {
            let errorMessage = "";
            if (err.response.data.message) {
              errorMessage = err.response.data.message[0].messages[0].message;
            } else {
              errorMessage = err.message;
            }

            reject(errorMessage);
          } catch (error) {
            reject(err.message);
          }
        });
      resolve(response.data);
    } catch (err) {
      reject(err);
    }
  });
}

export default login;
